import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useAppStore } from "../../../../../../../hooks/useStores";
import TgDatasetEditor from "../../../../../Datasets/Editor/TgDatasetEditor";

export const CreateTgModelDataset = () => {
	const { uiStore } = useAppStore();

	useEffect(() => {
		uiStore.hideSideBar();
	}, []);

	return <TgDatasetEditor />;
};

export default observer(CreateTgModelDataset);
